import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    // Paleta Educativa Moderna
    primary: {
      50: "#E6F7FF",
      100: "#BAE7FF", 
      200: "#91D5FF",
      300: "#69C0FF",
      400: "#40A9FF",
      500: "#1890FF", // Color principal - azul educativo
      600: "#096DD9",
      700: "#0050B3",
      800: "#003A8C",
      900: "#002766",
    },
    secondary: {
      50: "#F6FFED",
      100: "#D9F7BE",
      200: "#B7EB8F", 
      300: "#95DE64",
      400: "#73D13D",
      500: "#52C41A", // Verde académico
      600: "#389E0D",
      700: "#237804",
      800: "#135200",
      900: "#092B00",
    },
    accent: {
      50: "#FFF7E6",
      100: "#FFE7BA",
      200: "#FFD591",
      300: "#FFC069",
      400: "#FFAB40",
      500: "#FA8C16", // Naranja para destacar
      600: "#D46B08",
      700: "#AD4E00",
      800: "#873800",
      900: "#612500",
    },
    educational: {
      darkBlue: "#003A8C",
      lightBlue: "#E6F7FF", 
      success: "#52C41A",
      warning: "#FA8C16",
      error: "#FF4D4F",
      neutral: "#8C8C8C",
    },
    gray: {
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#D9D9D9",
      400: "#BFBFBF",
      500: "#8C8C8C",
      600: "#595959",
      700: "#434343",
      800: "#262626",
      900: "#1F1F1F",
    },
    // Paleta Datofy V1 (aditiva) — coral cálido + pasteles
    coral: {
      500: "#EF5A2A",
      600: "#DC4D20",
      700: "#C0411A",
      soft: "#FDE7DB",
      tint: "#FFF3EC",
    },
    mint: { bg: "#DCF1E6", ink: "#1E7A4E" },
    sky: { bg: "#E2ECFB", ink: "#2A66B4" },
    butter: { bg: "#FBEECB", ink: "#946F12" },
    lav: { bg: "#ECE6FB", ink: "#6849C4" },
    rose: { bg: "#FBE2EC", ink: "#C03F76" },
    teal: { bg: "#D6F0ED", ink: "#147F77" },
    amber: { bg: "#FCE7CC", ink: "#B5631A" },
    cream: {
      bg: "#FAF6F2",
      bg2: "#F4EEE7",
      line: "#EFE7DF",
      line2: "#E6DBD0",
    },
    ink: {
      900: "#2B2723",
      700: "#6E655C",
      400: "#A79C91",
    },
    ok: { 500: "#1E9E63", bg: "#DCF3E7" },
    warn: { 500: "#C77A12", bg: "#FBEECB" },
    danger: { 500: "#D6452B", bg: "#FBE0D9" },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode("#FAFAFA", "#1A1A1A")(props),
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        color: mode("#262626", "#FAFAFA")(props),
        lineHeight: '1.6',
      },
      html: {
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
      },
      "*::placeholder": {
        color: mode("#8C8C8C", "#595959")(props),
      },
      "*, *::before, &::after": {
        borderColor: mode("#EEEEEE", "#434343")(props),
      },
    }),
  },
};
